// grid组件的路由定义在这里

import commonGrid from '../components/grid/common-grid.vue'

// grid配置在这里，会自动生成路由
// !!!注意：这里的gridId不能重复，因为要作为生成路由的name使用
const grids = [
  {gridId: '', url: '', title: ''}
]

// 直接定义grid路由，配置参数更加灵活

// const basicMailViewSendStatus = {
//   name: 'basicMailViewSendStatus',
//   path: '/basic/mail/viewSendStatus',
//   title: '发送邮箱列表',
//   meta: {
//     permissionId: 'basicMailViewSendStatus',
//     url: '/entity/basic/peSite/abstractGrid?actionId=basic_peSite'
//   },
//   component: {
//     extends: backGrid
//   }
// }

const gridRouters = [
  // basicMailViewSendStatus
]

for (let i = 0; i < grids.length; i++) {
  let gridId = grids[i]['gridId']
  let url = grids[i]['url']
  let title = grids[i]['title']
  let router = {
    name: gridId,
    path: gridId,
    title: title,
    meta: {
      permissionId: gridId,
      url: url
    },
    component: {
      name: gridId,
      extends: commonGrid
    }
  }
  gridRouters.push(router)
}

export default gridRouters



// WEBPACK FOOTER //
// ./src/router/grid-routers.js